import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { CollateralManagementServerData } from '@lk/api'
import { loadCollateralManagementSession, unloadCollateralManagementSession } from './utility.actions'

export interface CollateralManagementSessionState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  data: CollateralManagementServerData
}

const initialCollateralManagementSessionState: CollateralManagementSessionState = {
  status: 'idle',
  error: null,
  data: null,
}

export const collateralManagementSessionReducer = createSlice({
  name: 'collateralManagementSession',
  initialState: initialCollateralManagementSessionState,
  reducers: {},
  extraReducers: {
    [loadCollateralManagementSession.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadCollateralManagementSession.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadCollateralManagementSession.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [unloadCollateralManagementSession.toString()]: () => initialCollateralManagementSessionState,
  },
}).reducer

export const utilityReducer = combineReducers({
  collateralManagementSession: collateralManagementSessionReducer,
})
